export default function () {
    return (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 4.34277H9.5C10.8807 4.34277 12 5.46206 12 6.84277V8.34277H9C7.89543 8.34277 7 7.44734 7 6.34277C7 5.2382 7.89543 4.34277 9 4.34277Z"
                stroke="url(#paint0_linear_1135_504)"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 4.34277H14.5C13.1193 4.34277 12 5.46206 12 6.84277V8.34277H15C16.1046 8.34277 17 7.44734 17 6.34277C17 5.2382 16.1046 4.34277 15 4.34277Z"
                stroke="url(#paint1_linear_1135_504)"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5 11.3428H19V19.3428C19 19.8951 18.5523 20.3428 18 20.3428H6C5.44772 20.3428 5 19.8951 5 19.3428V11.3428Z"
                stroke="url(#paint2_linear_1135_504)"
            />
            <path d="M12 11.3428L12 19.3428" stroke="url(#paint3_linear_1135_504)" strokeLinecap="square" strokeLinejoin="round" />
            <rect width="18" height="4" rx="1" transform="matrix(1 0 0 -1 3 12.3428)" fill="#FDF6E8" stroke="url(#paint4_linear_1135_504)" />
            <defs>
                <linearGradient id="paint0_linear_1135_504" x1="11.5" y1="7.34277" x2="5.5" y2="3.84277" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DCAE6B" />
                    <stop offset="1" stopColor="#C6904F" />
                </linearGradient>
                <linearGradient id="paint1_linear_1135_504" x1="16.5" y1="4.34277" x2="13.5" y2="5.84277" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F6D290" />
                    <stop offset="1" stopColor="#DBAC67" />
                </linearGradient>
                <linearGradient id="paint2_linear_1135_504" x1="18" y1="10.3428" x2="5" y2="20.3428" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7D390" />
                    <stop offset="1" stopColor="#C28A48" />
                </linearGradient>
                <linearGradient id="paint3_linear_1135_504" x1="12.5" y1="11.3428" x2="12.5" y2="19.3428" gradientUnits="userSpaceOnUse">
                    <stop offset="0.311967" stopColor="#E3B876" />
                    <stop offset="1" stopColor="#D5A462" />
                </linearGradient>
                <linearGradient id="paint4_linear_1135_504" x1="18" y1="2" x2="0" y2="2" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F1CB89" />
                    <stop offset="1" stopColor="#D19F5D" />
                </linearGradient>
            </defs>
        </svg>
    );
}
